import { BaseEntity } from '@base-entities';
import { ActivitySummaryTransformer } from '../transformers';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeActivitySummaryTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new ActivitySummaryTransformer<E>();
}
